<template>

  <div>
    <div class="main-content container-fluid">
      <div class="row">
        <div class="col-md-12">
          <PageHeader title="User Activity Report" subtitle="">
          </PageHeader>

          <Panel class="panel panel-default panel-border-color panel-border-color-primary">
            <div class="row  xs-p-40">
              <div class="col-sm-12 col-md-6">
                <div class="setting form-group row form-group-sm">
                  <label class="col-xs-4 col-form-label" for="txtStart">Start Date</label>
                  <div class="col-xs-8">
                    <datepicker v-model="startDate" format="yyyy-MM-dd" name="startDate" input-class="form-control"></datepicker>
                  </div>
                </div>
              </div><!-- /.col -->
              <div class="col-sm-12 col-md-6">
                <div class="setting form-group row form-group-sm">
                  <label class="col-xs-4 col-form-label" for="txtEnd">End Date</label>
                  <div class="col-xs-8">
                    <datepicker v-model="endDate" format="yyyy-MM-dd" name="endDate" input-class="form-control"></datepicker>
                  </div>  
                </div>
              </div><!-- /.col -->
            </div>
            <div class="row xs-p-40 xs-pt-0">
              <div class="col-xs-12">
                <button class="btn btn-primary btn-xl" v-on:click="downloadReport()" :disabled="saving">Download User Activity Report</button>
              </div>
            </div>
          </Panel>
        </div><!-- /div -->
      </div><!-- /div -->
    </div><!-- /div -->
  </div><!-- /div -->

</template>

<script>

  import { mapState, mapActions, mapGetters } from 'vuex';
  import userActivityExport from '../../../resources/userActivityExport'
  import Datepicker from 'vuejs-datepicker';
  import _ from 'underscore'



  export default {
    components: {
      Datepicker
    },

    created() {
      let date = new Date();
      this.startDate = date.getFullYear() + '-' + (date.getMonth() == 0 ? 12 : date.getMonth()) + '-' + date.getDate();
      this.endDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    },

    methods: {
      downloadReport() {
        if (this.startDate && this.endDate && new Date(this.startDate) < new Date(this.endDate)) {


          this.saving = true;
          var self = this;

          this.$store.dispatch('getUserActivityExport', {
            callback: function (result) {
              self.saving = false;

              var file = new Blob([result], { type: '.zip' });
              if (window.navigator.msSaveOrOpenBlob) // IE10+
                window.navigator.msSaveOrOpenBlob(file, 'user-activity.zip');
              else { // Others
                var a = document.createElement("a"),
                  url = URL.createObjectURL(file);
                a.href = url;
                a.download = 'user-activity.zip';
                document.body.appendChild(a);
                a.click();
                setTimeout(function () {
                  document.body.removeChild(a);
                  window.URL.revokeObjectURL(url);
                }, 0);
              }
            },
            failedCallback: function (result) {
              self.saving = false;
            },
            model: {
              start: this.startDate,
              stop: this.endDate,
            }
          });
        } else {
          Toast.error('Invalid date selection')
        }
      },
      
    },

    computed: {
      ...mapState([
      ]),

      
    },

    data() {
      return {
        saving: false,
        startDate: '',
        endDate: '',
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  
</style>



// WEBPACK FOOTER //
// useractivityreport.vue?8cc73728